import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`ユーザー登録とは`}</h2>
    <h3>{`設定方法`}</h3>
    <p>{`設定 >「ユーザー登録 / ログイン」から設定できます。`}</p>
    <img src="../../../account_001.png" width="200" />
    <p>{`ユーザー登録をすると以下の機能が使用可能になります。`}</p>
    <h3>{`通知機能`}</h3>
    <p><a parentName="p" {...{
        "href": "/general/notification"
      }}>{`通知機能とは`}</a></p>
    <h3>{`予定共有`}</h3>
    <p><a parentName="p" {...{
        "href": "/general/share"
      }}>{`予定共有とは`}</a></p>
    <h3>{`Web版ペペロミアを使用`}</h3>
    <p>{`以下のURLからWeb版ペペロミアを使用できるようになります。`}</p>
    <p><a parentName="p" {...{
        "href": "https://app.peperomia.info/"
      }}>{`Web版ペペロミア: https://app.peperomia.info/`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      